/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Blank_CtaInputs */

const en_us2_workout_blank_cta = /** @type {(inputs: Workout_Blank_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blank workout`)
};

const pt_br2_workout_blank_cta = /** @type {(inputs: Workout_Blank_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino em branco`)
};

const es_419_workout_blank_cta = /** @type {(inputs: Workout_Blank_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenamiento en blanco`)
};

const pt_pt2_workout_blank_cta = /** @type {(inputs: Workout_Blank_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino em branco`)
};

const fr_fr2_workout_blank_cta = /** @type {(inputs: Workout_Blank_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séance vierge`)
};

const de_de2_workout_blank_cta = /** @type {(inputs: Workout_Blank_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leeres Training`)
};

const it_it2_workout_blank_cta = /** @type {(inputs: Workout_Blank_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamento vuoto`)
};

/**
* | output |
* | --- |
* | "Blank workout" |
*
* @param {Workout_Blank_CtaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_blank_cta = /** @type {((inputs?: Workout_Blank_CtaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Blank_CtaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_blank_cta(inputs)
	if (locale === "es-419") return es_419_workout_blank_cta(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_blank_cta(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_blank_cta(inputs)
	if (locale === "de-DE") return de_de2_workout_blank_cta(inputs)
	if (locale === "it-IT") return it_it2_workout_blank_cta(inputs)
	return en_us2_workout_blank_cta(inputs)
});
export { workout_blank_cta as "workout.blank_cta" }